<template>
  <div class="row align-items-center mb-3 w-100">
      <div class="p-game-tab-items row w-100 align-items-start justify-content-center">
            <div :class="{'p-game-tab-active':data.active}" @click="activeTab(data)" v-for="data in tabData" :key="data.id" class=" p-game-tab-item align-items-start">
                <h3 class="p-game-tab-item-title">{{data.title}}</h3>
            </div>
      </div>
  </div>
</template>

<script>


export default {
  name: 'gameTab',
  props: {
    textTime : {type:String,default:''},
  },

  data() {
    return {
      tabData : [
        {
          id     : 1,
          title  : 'بازی های انجام شده',
          active : true,
          stateActiveTab : 'passed',
        },
        {
          id    : 2,
          title : 'بازی های آینده',
          active : false,
          stateActiveTab : 'future',
        },
        {
          id    : 3,
          title : 'جدول امتیاز افراد',
          active : false,
          stateActiveTab : 'scorers_table',
        },
        {
          id    : 4,
          title : 'جدول گروهی ',
          active : false,
          stateActiveTab : 'group_stage_table',
        },
        {
          id    : 5,
          title : 'جدول حذفی ',
          active : false,
          stateActiveTab : 'knockout_stage_table',
        },
        {
          id    : 7,
          title : 'تیم ها',
          active : false,
          stateActiveTab : 'allTeams',
        },
      ]
    }
  },

  computed: {

  },

  watch: {

  },

  mounted () {
    const getParamsCheckFuturePassed = this.$route.params.state_match_check_future_passed;
    const getStateActiveTab          = this.$route.params.state_active_tab;

    if (typeof(getParamsCheckFuturePassed) != 'undefined') {
      this.findActiveTab({stateActiveTab:getParamsCheckFuturePassed});
    }
    else {
      this.findActiveTab({stateActiveTab:getStateActiveTab});
    }




  },

  methods: {
    findActiveTab(data) {
      this.tabData.map((t)=>{
        if (t.stateActiveTab == data.stateActiveTab) {
          t.active = true
        }
        else {
          t.active = false
        }
      })
    },

    activeTab(data){
      this.findActiveTab(data);

      switch (data.stateActiveTab) {
          case 'future':
            this.$router.push({name:'gameFuture' , params:{state_match_check_future_passed:'future'}})
          break;

          case 'passed':
            this.$router.push({name:'gameFuture' , params:{state_match_check_future_passed:'passed'}})
          break;

          case 'scorers_table':
          this.$router.push({name:'tabScorersAndKnockoutAndGroup' , params:{state_active_tab:'scorers_table'}})
          break;

          case 'group_stage_table':
            this.$router.push({name:'tabScorersAndKnockoutAndGroup' , params:{state_active_tab:'group_stage_table'}})
          break;

          case 'knockout_stage_table':
            this.$router.push({name:'tabScorersAndKnockoutAndGroup' , params:{state_active_tab:'knockout_stage_table'}})
          break;

          case 'allTeams':
            this.$router.push({name:'Team' , params:{state_active_tab:'allTeams'}})
          break;

        default:

      }

      console.log(data);

      this.$emit('changeTabGame',data)


    }

  },

}
</script>
